module.exports = __webpack_public_path__ + "static/media/mmm-icon-plus.718f2d5c.svg";